import { RegistrationService } from './../../registration.service';
import { Component, OnInit } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser'
import {Subject} from 'rxjs/Subject';
import { SainikSchemesModel,SainikSchemeApplicationModel} from './../../shared/user.model';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Title } from '@angular/platform-browser/src/browser/title';
import { NgForm } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {  
  maintitle="Schemes Available";
  id: number;
  formSubmitted: boolean;
  inputVar: string;
  SainikSchemesDetails:any={};
  itemsPerPage: number=5;
  currentPage: number=1;  
  totalItems: number;
  sainikSchemeApplicationModel : SainikSchemeApplicationModel;
  Relations: any=[];
  data: any;
  re:any;
  d:any={};
  s:any={};
  regiments: any=[];
  r:any={};
  e:any={};
  w: any={};
  m: any={};
  formInvalid: boolean;
  Relegions: any=[];
  dependents: any=[];
  sg: any={};
  cf: any={};
  emp: any={};
  hg: any={};
  DOBempty: boolean;
  mode : any;
  sgs:any={};
  cs:any={};
  drg:any={};
  ca:any={};
  arg:any={};

  myDate = new Date();
  applicationstatus: any;
  fileToUpload: File =null;
  // signatureimageUrl: any;
  signatureimageUrl: string = "assets/images/image-default.png";
  thumbimpressionimageUrl : string = "assets/images/image-default.png";
  dirsignatureimageUrl : string = "assets/images/image-default.png";
  esmsignatureimageUrl: string = "assets/images/image-default.png";
  issuingauthoritysignatureimageUrl: string = "assets/images/image-default.png";
  leftthumbimpressionimageUrl: string = "assets/images/image-default.png";
  signatureOfapplicantimageUrl: string = "assets/images/image-default.png";
  rightthumbimpressionimageUrl: string = "assets/images/image-default.png";
  signatureofapplicantwidowsimageUrl: string = "assets/images/image-default.png";
  signatureofapplicantmarriagegrantimageUrl: string = "assets/images/image-default.png";
  Daughter_TCPath: any;
  UploadMarksSheetPath: any;
  UploadRecordOfficeDocPath: any;
  UploadDischargeBookPath: any;
  UploadSSLCMarksSheetPath: any;
  UploadCETapplicationPath: any;
  ESMSignaturePath: any;
  PPoUploadPath: any;
  PropertpapersUploadPath: any;
  UserName: string;
  RoleName: string;
  schemeapplicationStatus: any;
  schemeApp_Status: any;
  schemeapplicationStatusId: any;
  gn: any={};
  DaughterNamesList: any=[];
  rd:any={};
  Formdisable: boolean = false;
  ApplicationStatus: any;
  ApplicationId: any;
  ApplicationStatusName: any;
  UploadIdNumber: any;
  Esd_Radio: any;
 // ApplicationStatusIdview: any=null;
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {

  }

  ngOnInit() {
    this.sainikSchemeApplicationModel = new SainikSchemeApplicationModel;
    this.GetAllSainikSchemes(this.itemsPerPage, 1);
    this.GetAllRelations();
    //this.GetSainikDetailsForDependentIdCard(this.s.serviceNo);
    this.GetRegiments();
    this.GetAllRelegions();
    
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.ServiceNo=this.UserName;
    this.GetAllApplications(this.UserName);
    this.GetDaughterNamesForDropdown(this.UserName);
    }
  }


  GetAllApplications(serviceNo:any)
  {
    if(serviceNo!=null || undefined)
    {
    this.GetAllSainikSchemes(this.itemsPerPage, 1);
    this.GetSainikDetailsForDependentIdCard(serviceNo);
    this.GetExServiceManIdCardDetails(serviceNo);
    this.GetWidowIdCardDetails(serviceNo);
    this.GetMarriageGrantOfDaughterFormDetails(serviceNo);


    this.GetDetailsForSpectacleGrantForm(serviceNo);
    this.GetDetailsForCETCertificateForm(serviceNo);
    this.GetDetailsForEmploymentRegistrationform(serviceNo);
    this.GetDetailsForHouseRepairGrantform(serviceNo);

    this.GetDetailsForStateGovtScholarshipform(serviceNo);
    this.GetDetailsForChildrenGrantScholarshipform(serviceNo);
    this.GetDetailsForGallantryNonGallantryform(serviceNo);
    this.GetDetailsForDeathReliefGrantform(serviceNo);

    this.GetDetailsForCashAwardform(serviceNo);
    this.GetDetailsForAnnualReliefGrantForm(serviceNo);
    }
    else{
      swal("Please enter Service No.");
    }
  }


  
  openModalDialog(id,name,appstatus,ApplicationStatusId,applicationId,ApplicationStatusName) {
    //alda
    /*
    alert(id)
    alert(appstatus)
    alert('openModalDialog')
    return;
    */
    
    this.id=id;
    this.ApplicationStatus=appstatus;
    this.ApplicationId=applicationId;
    this.ApplicationStatusName=ApplicationStatusName;
    if(id==1)
    {
     $("#ApplicationForm1").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null" ||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==2)
    {
      $("#ApplicationForm2").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==3)
    {
      $("#ApplicationForm3").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==4)
    {
      $("#ApplicationForm4").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==10)
    {
      $("#ApplicationForm5").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==11)
    {
      $("#ApplicationForm6").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if(id==12)
    {
      $("#ApplicationForm7").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }

    else if(id==1008)
    {
      $("#ApplicationForm8").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }

    else if (id == 2009) {
      $("#ApplicationForm9").modal('show'); 
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      } 
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }    
    }
    else if (id == 2010) {
      $("#ApplicationForm10").modal('show'); 
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      } 
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }    
    }
    else if (id == 2011) {
      $("#ApplicationForm11").modal('show'); 
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }  
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }   
    }
    else if (id == 2012) {
      $("#ApplicationForm12").modal('show'); 
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      } 
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }    
    }
    else if (id == 2013) {
      $("#ApplicationForm13").modal('show');
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      }      
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }
    }
    else if (id == 2014) {
      $("#ApplicationForm14").modal('show'); 
      if(appstatus=="Applied")
      {
        this.Formdisable = true;
      } 
      if(appstatus==""|| appstatus=="undefined"|| appstatus=="null"||ApplicationStatusId==11){
        this.Formdisable = false;
      }    
    }

    //fr staging
    // else if (id == 1009) {
    //   $("#ApplicationForm9").modal('show');      
    // }
    // else if (id == 1010) {
    //   $("#ApplicationForm10").modal('show');      
    // }
    // else if (id == 1011) {
    //   $("#ApplicationForm11").modal('show');      
    // }
    // else if (id == 1012) {
    //   $("#ApplicationForm12").modal('show');      
    // }
    // else if (id == 1013) {
    //   $("#ApplicationForm13").modal('show');      
    // }
    // else if (id == 1014) {
    //   $("#ApplicationForm14").modal('show');      
    // }
  }

  EditDependents(id,name) {   
    this.inputVar = name;
    this.id = id;    
    //this.fd['SD_Qualifictaion']=this.FamilyDetails[i].Qualifications.Q_Id;
    //   this.Removefamily(i);  
    //this.closeModalDialog();
  }

  closeModalDialog() {
    $("#ApplicationForm").modal('hide');
  }


  pageChanged(pageNumber:number)
  {    
    this.GetAllSainikSchemes(this.itemsPerPage, pageNumber);
  }
  
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {    
    this.GetAllSainikSchemes(this.itemsPerPage, pageNo);
  }

  GetAllSainikSchemes(itemsPerPage: number, pageNo: number) 
  {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllSainikSchemes(itemsPerPage,pageNo,this.s.ServiceNo)
      .subscribe(
        (data:any) => {
          this.SainikSchemesDetails = data.SainikSchemesModels;
          this.schemeapplicationStatusId= data.SainikSchemesModels.ApplicationStatusId;
          this.schemeApp_Status= data.SainikSchemesModels.App_Status;
          // if(this.schemeApp_Status=="Applied"){
          //   this.Formdisable = true;
          // }

          this.applicationstatus='view';
          // this.ApplicationStatusIdview=data.SainikSchemesModels[0].ApplicationStatusId;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  SavedepId(dependentId: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (dependentId.valid) {
        this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;
    
      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveDependentIdCardDetails(dependentId);
     }
     else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("please select service no.")
    }
  }

//save appl2 esm id card details
  SaveAllESMIdCard(exservicemanId: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (exservicemanId.valid) {
        this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;     
      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;    
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.GetAllApplications(this.UserName);
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveESMIdCardDetails(exservicemanId);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }

  //save appl and marriagegrant details
  SaveAllMarriageGrantFormDetails(marriagegrantId: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (marriagegrantId.valid) {
        this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveMarriageGrantFormDetails(marriagegrantId);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }

  //save appl and SpectacleGrantFormDetails
  SaveAllSpectacleGrantFormDetails(spectaclegrant: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (spectaclegrant.valid) {
        this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;

      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveSpectacleGrantFormDetails(spectaclegrant);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }


  //save appl and cet certificate form
  SaveAllCETCertificateForm(cetform: NgForm) {
   if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
  {
    if (cetform.valid) {
      this.formInvalid = false;
 document.getElementById('loader-spinner').style.display = "block";
   this.sainikSchemeApplicationModel.Scheme_Id = this.id;
   this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

   this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
   this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
   this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
   this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
   (data:any) => {
     document.getElementById('loader-spinner').style.display = "none";
     swal('','Application Form Submitted Successfully!','success');
     //this.closeModalDialogApplicationForms(this.id);
     //this.router.navigate(['/home/SchemesApprovals']);
     this.router.navigate(['/home/dashboardschemes']);
   }, (error) => {
     document.getElementById('loader-spinner').style.display="none";
     this.errorHandler.HandlerError(error);
   });
 this.SaveCETCertificateFormDetails(cetform);
 }
 else{
  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
  this.formInvalid = true;
 }
}
 else{
   swal("Please select Service No.")
 }
}

//save appl and empreg form details
SaveAllEmploymentRegistrationForm(empregistration: NgForm){
  if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
  {
    if (empregistration.valid) {
      this.formInvalid = false;
 document.getElementById('loader-spinner').style.display = "block";
   this.sainikSchemeApplicationModel.Scheme_Id = this.id;
   this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

   this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
   this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
   this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
   this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
   (data:any) => {
     document.getElementById('loader-spinner').style.display = "none";
     swal('','Application Form Submitted Successfully!','success');
     //this.closeModalDialogApplicationForms(this.id);
     //this.router.navigate(['/home/SchemesApprovals']);
     this.router.navigate(['/home/dashboardschemes']);
   }, (error) => {
     document.getElementById('loader-spinner').style.display="none";
     this.errorHandler.HandlerError(error);
   });
 this.SaveEmploymentRegistrationFormDetails(empregistration);
 }
 else{
  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
  this.formInvalid = true;
 }
}
 else{
   swal("Please select Service No.")
 }
}


//save appl and houserepairgrant form details
SaveAllHouseRepairGrantform(houserepairgrant: NgForm){
  if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
  {
    if (houserepairgrant.valid) {
      this.formInvalid = false;
 //this.SaveApplicationForm(form);
 document.getElementById('loader-spinner').style.display = "block";
   this.sainikSchemeApplicationModel.Scheme_Id = this.id;
   this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

   this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
   this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
   this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
   this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
   (data:any) => {
     document.getElementById('loader-spinner').style.display = "none";
     swal('','Application Form Submitted Successfully!','success');
     //this.closeModalDialogApplicationForms(this.id);
     //this.router.navigate(['/home/SchemesApprovals']);
     this.router.navigate(['/home/dashboardschemes']);
   }, (error) => {
     document.getElementById('loader-spinner').style.display="none";
     this.errorHandler.HandlerError(error);
   });
 this.SaveHouseRepairGrantformDetails(houserepairgrant);
 }
 else{
  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
  this.formInvalid = true;
 }
}
 else{
   swal("Please select Service No.")
 }
}


  //save appl3 widow id card details
  SaveAllWidowIdCard(WidowsIdcard: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (WidowsIdcard.valid) {
        this.formInvalid = false;
    //this.SaveApplicationForm(form);
    document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveWidowIdCardDetails(WidowsIdcard);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }


  CancelWidowIdCardDetails()
  {
    this.w={};
    this.GetWidowIdCardDetails(this.s.ServiceNo);
  }

  CancelDependentIdCardDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.d={};
    this.GetSainikDetailsForDependentIdCard(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelEXIdCardDetails(){
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.e={};
    this.GetExServiceManIdCardDetails(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelMGrantIdCardDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.m={};
    this.GetMarriageGrantOfDaughterFormDetails(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelCETIdDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.cf={};
    this.GetDetailsForCETCertificateForm(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelSpectacleIdDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.sg={};
    this.GetDetailsForSpectacleGrantForm(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelEmpRegistrationIdDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.sg={};
    this.GetDetailsForEmploymentRegistrationform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelHouseRepairIdDetails()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.sg={};
    this.GetDetailsForHouseRepairGrantform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelStateScholarshipForm()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.sgs={};
    this.GetDetailsForStateGovtScholarshipform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelChildrenScholarshipForm()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.cs={};
    this.GetDetailsForChildrenGrantScholarshipform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }

  CancelGNGForm()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.drg={};
    this.GetDetailsForGallantryNonGallantryform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }


  CancelCashAwardForm()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.ca={};
    this.GetDetailsForCashAwardform(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }


  CancelARGForm()
  {
    if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
    {
    this.ca={};
    this.GetDetailsForAnnualReliefGrantForm(this.s.ServiceNo);
    }
    else {
      swal("Please select Service No.");
    }
  }




  SaveApplicationForm(form)
  {
    if (!form.invalid)
    {
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
      //this.sainikSchemeApplicationModel.Scheme_Id = 1;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.closeModalDialog();
        //this.router.navigate(['/home/SchemesApprovals']);
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
      this.formSubmitted = true;
    }
  }

  //Save Dependent Details
  SaveDependentIdCardDetails(dependentId: NgForm) { 
    /*   
    console.log('hit Dependent Id Card')
    alert('hit Dependent Id Card')
    return;
    */

     if (dependentId.valid) {
      this.formInvalid = false;
       document.getElementById('loader-spinner').style.display = "block";
       dependentId.value.DID_AppliedDate=this.myDate;
       dependentId.value.DID_DirAppliedDate=this.myDate;
      this.data = this.userService.saveDependentIdCardDetails(dependentId.value);
      this.data.subscribe(
        (response) => {
          dependentId.reset();
          dependentId.resetForm();    
          $("#ApplicationForm1").modal('hide');   
          swal('Success!', 'Dependent Id Card Details saved Successfully.', 'success');
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
          this.router.navigate(['/home/dashboardschemes']);
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }



  //For App1 Dependent Id Cardform

  GetAllRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllRelations();
    this.data.subscribe(
      (response) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetSainikDetailsForDependentIdCard(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSainikDetailsForDependentIdCard(this.s.ServiceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.d = data;
          this.d.DID_AppliedDate=this.myDate;
          this.d.DID_DirAppliedDate=this.myDate;
          if(this.d!=null)
          // if(data.DID_AppliedDate!=null)
          //  this.d.DID_AppliedDate=this.myDate;
          if(data.SR_DOB!=null)
          this.d.SR_DOB=((data.SR_DOB).split('T'))[0];
          if(data.SD_DOB!=null)
          this.d.SD_DOB=((data.SD_DOB).split('T'))[0];
          if(data.DateOfjoinedService!=null)
          this.d.DateOfjoinedService=((data.DateOfjoinedService).split('T'))[0];
          if(data.DateOfRetirement!=null)
          this.d.DateOfRetirement=((data.DateOfjoinedService).split('T'))[0];
          if(data.DependentIdValidUpTo!=null)
          this.d.DependentIdValidUpTo=((data.DependentIdValidUpTo).split('T'))[0];
          if(data.DependentIdIssuedOn!=null)
          this.d.DependentIdIssuedOn=((data.DependentIdIssuedOn).split('T'))[0];
          if(data.DependentSignature!=null)
          this.signatureimageUrl=data.DependentSignaturePath;
          if(data.DependentThumbImpression!=null)
          this.thumbimpressionimageUrl=data.DependentThumbImpressionPath;
          if(data.ESMSignature!=null)
          this.esmsignatureimageUrl=data.ESMSignaturePath;
          if(data.DirSignature!=null)
          this.dirsignatureimageUrl=data.DirSignaturePath;
          if(data.IssuingAuthoritySignature!=null)
          this.issuingauthoritysignatureimageUrl=data.IssuingAuthoritySignaturePath;

          if(data.DID_AppliedDate!=null)
          this.d.DID_AppliedDate=((data.DID_AppliedDate).split('T'))[0];
          if(data.DID_DirAppliedDate!=null)
          this.d.DID_DirAppliedDate=((data.DID_DirAppliedDate).split('T'))[0];
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //Ex-serviceMan ID Card Appl2


  GetAllRelegions() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllRelegions();
    this.data.subscribe(
      (response) => {
        this.Relegions = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetRegiments() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getRegiments();
    this.data.subscribe(
      (response) => {
        this.regiments=response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }



  GetDaughterNamesForDropdown(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getDaughterNamesForDropdown(serviceNo);
    this.data.subscribe(
      (response) => {
        this.DaughterNamesList = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  //ExServiceManIdCard
  GetExServiceManIdCardDetails(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getExServiceManIdCardDetails(this.s.ServiceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.e = data;
          if(data.ESMID_Upload!=null)
          this.UploadIdNumber=data.ESMID_Upload;
         // this.e.RadioButtonFLM=this.Esd_Radio;
          this.e.ESMId_AppliedDate=this.myDate;
          this.dependents=data.SainikDependents;
          if(data.SR_DOB!=null){
          this.e.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.CalculateAgeexservice(this.e.SR_DOB);
          }

          if(data.SP_DischargeBookDate!=null)
          this.e.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          if(data.SP_PPODate!=null)
          this.e.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          if(data.SR_DischargeDate!=null)
          this.e.SR_DischargeDate=((data.SR_DischargeDate).split('T'))[0];
          if(data.DateOfEnrollment!=null)
          this.e.DateOfEnrollment=((data.DateOfEnrollment).split('T'))[0];
          if(data.leftThumbImpession!=null)
          this.leftthumbimpressionimageUrl=data.leftThumbImpessionPath;
          if(data.SignatureOfApplicant!=null)
          this.signatureOfapplicantimageUrl=data.SignatureOfApplicantPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

//Widow Id Card
  GetWidowIdCardDetails(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getWidowIdCardDetails(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.w = data;
          console.log('data :' +this.w)
          this.w.WidowID_AppliedDate=this.myDate;
          if(data.DateOfDischarge!=null)
          this.w.DateOfDischarge=((data.DateOfDischarge).split('T'))[0];
          if(data.DateOfEnrollment!=null)
          this.w.DateOfEnrollment=((data.DateOfEnrollment).split('T'))[0];
          if(data.SR_DOD!=null)
          this.w.SR_DOD=((data.SR_DOD).split('T'))[0];
          if(data.WidowDOB!=null)
          this.w.WidowDOB=((data.WidowDOB).split('T'))[0];
          // if(this.w.WidowDOB !=null)
          // {
          // this.DateOfBirthValidation()
          // }
          if(data.RightThumbImpession!=null)
          this.rightthumbimpressionimageUrl=data.RightThumbImpessionPath;
          if(data.SignatureofApplicant!=null)
          this.signatureofapplicantwidowsimageUrl=data.SignatureofApplicantPath;
          console.log("Widimg",this.signatureofapplicantwidowsimageUrl, this.rightthumbimpressionimageUrl);
          // this.w.SR_DOB=((data.SR_DOB).split('T'))[0];
          if(data.SP_PPODate!=null)
          this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          // this.w.SR_DOD=((data.SR_DOD).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  //marriage grant form
  GetMarriageGrantOfDaughterFormDetails(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getMarriageGrantOfDaughterFormDetails(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.m = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           this.m.MGrant_AppliedDate=this.myDate;
          if(data.Daughter_TC!=null)
          this.Daughter_TCPath=data.Daughter_TC;
           if(data.SignatureofApplicant!=null)
          this.signatureofapplicantmarriagegrantimageUrl=data.SignatureofApplicantPath;
          if(data.DateofEnrollement!=null)
          this.m.DateofEnrollement=((data.DateofEnrollement).split('T'))[0];
          if(data.DateofDischarge!=null)
          this.m.DateofDischarge=((data.DateofDischarge).split('T'))[0];

          if(data.SR_DOD!=null)
           this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(data.Daughter_DOB!=null)
           this.m.Daughter_DOB=((data.Daughter_DOB).split('T'))[0];
          

          //  if(this.m.Daughter_DOB !=null)
          //  {
          //   this.CalculateAge();
          //  }
           if(data.Daughter_MarriageDate!=null)
           this.m.Daughter_MarriageDate=((data.Daughter_MarriageDate).split('T'))[0];
           if(data.Marriage_Date!=null)
           this.m.Marriage_Date=((data.Marriage_Date).split('T'))[0];

           if(data.TotalService==0)
           this.m.TotalService="";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //spectacle grant form
  GetDetailsForSpectacleGrantForm(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForSpectacleGrantForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.sg = data;
          // this.sg.Date=this.myDate;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(data.DateofDischarge!=null)
           this.sg.DateofDischarge=((data.DateofDischarge).split('T'))[0];
           if(data.DateofEnrollement!=null)
           this.sg.DateofEnrollement=((data.DateofEnrollement).split('T'))[0];
           if(data.SR_DOD!=null)
           this.sg.SR_DOD=((data.SR_DOD).split('T'))[0];

           if(data.DateOfjoinedService!=null)
           this.d.DateOfjoinedService=((data.DateOfjoinedService).split('T'))[0];
         
       

           if(data.Date!=null)
           this.sg.Date=((data.Date).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForCETCertificateForm
  GetDetailsForCETCertificateForm(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForCETCertificateForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.cf = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(data.DateofEnrollement!=null)
           this.cf.DateofEnrollement=((data.DateofEnrollement).split('T'))[0];
           if(data.DateofDischarge!=null)
           this.cf.DateofDischarge=((data.DateofDischarge).split('T'))[0];
           if(data.Date!=null)
           this.cf.Date=((data.Date).split('T'))[0];
           if(data.UploadMarkSheets!=null)
           this.UploadMarksSheetPath=data.UploadMarkSheetsPath;

          

           //
           if(data.UploadRecordOfficeDoc!=null)
           this.UploadRecordOfficeDocPath=data.UploadRecordOfficeDocPath;
           if(data.UploadDischargeBook!=null)
           this.UploadDischargeBookPath=data.UploadDischargeBookPath;
           if(data.UploadSSLCMarksSheet!=null)
           this.UploadSSLCMarksSheetPath=data.UploadSSLCMarksSheetPath;
           if(data.UploadCETApplication!=null)
           this.UploadCETapplicationPath=data.UploadCETApplicationPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForEmploymentRegistrationform
  GetDetailsForEmploymentRegistrationform(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForEmploymentRegistrationform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.emp = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(this.emp.Date!=null)
           this.emp.Date=((data.Date).split('T'))[0];
           if(data.ESMSignature!=null)
           this.ESMSignaturePath=data.ESMSignaturePath;

        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForHouseRepairGrantform
  GetDetailsForHouseRepairGrantform(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForHouseRepairGrantform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.hg = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(this.hg.Date!=null)
           this.hg.Date=((data.Date).split('T'))[0];
           if(this.hg.DateofEnrollment!=null)
           this.hg.DateofEnrollment=((data.DateofEnrollment).split('T'))[0];
           if(this.hg.DateofInjuryorDeath!=null)
           this.hg.DateofInjuryorDeath=((data.DateofInjuryorDeath).split('T'))[0];
           if(this.hg.HandingOverDate!=null)
           this.hg.HandingOverDate=((data.HandingOverDate).split('T'))[0];
           if(data.UploadPPO!=null)
           this.PPoUploadPath=data.UploadPPOPath;
           if(data.Uploadpropertypapers!=null)
           this.PropertpapersUploadPath=data.UploadpropertypapersPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForStateGovtScholarshipform
  GetDetailsForStateGovtScholarshipform(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForStateGovtScholarshipform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.sgs = data;
           if(this.sgs.SGS_DOB!=null)
           this.sgs.SGS_DOB=((data.SGS_DOB).split('T'))[0];
           
           if(data.SGS_NP_Pincode==0)
           this.sgs.SGS_NP_Pincode="";

           if(data.SGS_PA_Pincode==0)
           this.sgs.SGS_PA_Pincode="";

           if(data.SGS_GuardianPincode==0)
           this.sgs.SGS_GuardianPincode="";

           if(data.SGS_ClassPresentYear==0)
           this.sgs.SGS_ClassPresentYear="";

           if(data.SGS_ClassPreviousYear==0)
           this.sgs.SGS_ClassPreviousYear="";
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }




  //Save ESM ID Card Details
  SaveESMIdCardDetails(exservicemanId: NgForm) {    
    
     if (exservicemanId.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      exservicemanId.value.ESMId_AppliedDate=this.myDate;
      exservicemanId.value.UploadIdNumber = this.GetIdCardNumberUpload();
      this.data = this.userService.saveESMIdCardDetails(exservicemanId.value);
      this.data.subscribe(
        (response) => {
          exservicemanId.reset();
          exservicemanId.resetForm();  
          $("#ApplicationForm2").modal('hide');    
          swal('Success!', 'Exserviceman Id Card Details saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ; 
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
          this.router.navigate(['/home/dashboardschemes']);
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }



   //Save Widow ID Card Details
   SaveWidowIdCardDetails(WidowsIdcard: NgForm) {    
    
     if (WidowsIdcard.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.saveWidowIdCardDetails(WidowsIdcard.value);
      this.data.subscribe(
        (response) => {
          WidowsIdcard.reset();
          WidowsIdcard.resetForm();   
          this.dependents=[];  
          $("#ApplicationForm3").modal('hide');  
          swal('Success!', 'Widow Id Card Details saved Successfully.', 'success');
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
          this.router.navigate(['/home/dashboardschemes']) ;  
          //this.router.navigate(['/home/SchemesApprovals']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  CalculateAge()
  {
    // debugger;
    let ageofcust;
    this.DOBempty=false;
    if(this.m.Daughter_DOB.length>10)
     swal('Date','Enter correct date')
    else if (this.m.Daughter_DOB) {
    //convert date again to type Date
    const bdate = new Date(this.m.Daughter_DOB);
    const timeDiff = Math.abs(Date.now() - bdate.getTime() );
    this.m.Daughter_Age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    if(ageofcust<18)
    {
      swal('Warning','Age must be greater than 18 years old',"warning");
      this.m.Daughter_DOB='';
      this.m.Daughter_Age='';
      
    }
  }
  }


  // CalculateAgeexservice(SR_DOB)
  // {
  //  debugger;
  //   let ageofcust;
  //   this.DOBempty=false;
  //   if(SR_DOB.length>10)
  //    swal('Date','Enter correct date')
  //   else if (SR_DOB) {
  //   //convert date again to type Date
  //   const bdate = new Date(SR_DOB);
  //   const timeDiff = Math.abs(Date.now() - bdate.getTime() );
  //   this.e.SD_Age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  //   ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  //   if(ageofcust<18)
  //   {
  //     swal('Warning','Age must be greater than 18 years old',"warning");
  //     this.e.SR_DOB='';
     

      
  //   }
  //   console.log("this age");
  //   console.log(this.e.SD_Age);
  // }
  // }

//my
  DateOfBirthValidation(){
    
    let ageofcust;
    this.DOBempty=false;
    if(this.w.WidowDOB.length>10)
     swal('Date','Enter correct date')
    else if (this.w.WidowDOB) {
    //convert date again to type Date
    const bdate = new Date(this.w.WidowDOB);
    const timeDiff = Math.abs(Date.now() - bdate.getTime() );
    // this.m.Daughter_Age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    ageofcust= Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    if(ageofcust<18)
    {
      swal('Warning','Age must be greater than 18 years old',"warning");
      this.w.WidowDOB='';
      // this.m.Daughter_Age='';
    }
  }
  }


   //Save MarriageGrantofDaughterDetails
   SaveMarriageGrantFormDetails(marriagegrantId: NgForm) {    
    
     if (marriagegrantId.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      marriagegrantId.value.MGrant_AppliedDate=this.myDate;
      this.data = this.userService.saveMarriageGrantFormDetails(marriagegrantId.value);
      this.data.subscribe(
        (response) => {
          marriagegrantId.reset();
          marriagegrantId.resetForm();   
          $("#ApplicationForm4").modal('hide');      
          swal('Success!', 'MarriageGrantDetails saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ;
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
           this.router.navigate(['/home/dashboardschemes']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }



  //Save SpectacleGrantofDaughterDetails
  SaveSpectacleGrantFormDetails(spectaclegrant: NgForm) {    
    
     if (spectaclegrant.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.saveSpectacleGrantFormDetails(spectaclegrant.value);
      this.data.subscribe(
        (response) => {
          spectaclegrant.reset();
          spectaclegrant.resetForm();
          $("#ApplicationForm5").modal('hide');   
          swal('Success!', 'SpectacleGrantDetails saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ;
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
           this.router.navigate(['/home/dashboardschemes']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  //Save CETcertificateDetails
  SaveCETCertificateFormDetails(cetform: NgForm) {    
    
     if (cetform.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.saveCETCertificateFormDetails(cetform.value);
      this.data.subscribe(
        (response) => {
          cetform.reset();
          cetform.resetForm();   
          $("#ApplicationForm6").modal('hide');     
          swal('Success!', 'CET Certificate Details saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ;
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
           this.router.navigate(['/home/dashboardschemes']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }



  //Save EmploymentRegistrationDetails
  SaveEmploymentRegistrationFormDetails(empregistration: NgForm) {    
    
     if (empregistration.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      empregistration.value.ServiceNo=this.s.ServiceNo;
      this.data = this.userService.saveEmploymentRegistrationFormDetails(empregistration.value);
      this.data.subscribe(
        (response) => {
          empregistration.reset();
          empregistration.resetForm(); 
          $("#ApplicationForm7").modal('hide');      
          swal('Success!', 'Employment Registration Details saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ;
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
           this.router.navigate(['/home/dashboardschemes']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  //Save House Repair Grant details
  SaveHouseRepairGrantformDetails(houserepairgrant: NgForm) {    
    
     if (houserepairgrant.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.saveHouseRepairGrantformDetails(houserepairgrant.value);
      this.data.subscribe(
        (response) => {
          houserepairgrant.reset();
          houserepairgrant.resetForm(); 
          $("#ApplicationForm8").modal('hide');       
          swal('Success!', 'HouseRepairGrantDetails saved Successfully.', 'success');
          //this.router.navigate(['/home/SchemesApprovals']) ;
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
           this.router.navigate(['/home/dashboardschemes']) ;   
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  ClearAllForms()
  {
    this.s.ServiceNo="";
    this.d={};
    this.e={};
    this.w={};
    this.m={};
    this.sg={};
    this.cf={};
    this.emp={};
    this.hg={};
    this.dependents=[];
  }

  //Dependent id form  images

   //dependent signature
   SignatureFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.DependentSignature="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.signatureimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('DependentSignature');
          i.value="";
          if (error.status == 400) {
            this.signatureimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('DependentSignature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }


  getSignatureImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('DependentSignature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  //dependent thumbimpression
  ThumbImpressionFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.DependentThumbImpression="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.thumbimpressionimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('DependentThumbImpression');
          i.value="";
          if (error.status == 400) {
            this.thumbimpressionimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('DependentThumbImpression');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }


  getThumbImpressionImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('DependentThumbImpression');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //dependentId ESMSignature
  ESMSignatureFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.ESMSignature="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.esmsignatureimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('ESMSignature');
          i.value="";
          if (error.status == 400) {
            this.esmsignatureimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('ESMSignature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getESMSignatureImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('ESMSignature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  //dependentId DIRSignature
  DirSignatureFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.ESMSignature="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.dirsignatureimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('DirSignature');
          i.value="";
          if (error.status == 400) {
            this.dirsignatureimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('DirSignature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getDIRSignatureImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('DirSignature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  //dependentId IssuingAuthoritySignature
  IssuingAuthoritySignatureFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.IssuingAuthoritySignature="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.issuingauthoritysignatureimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('IssuingAuthoritySignature');
          i.value="";
          if (error.status == 400) {
            this.issuingauthoritysignatureimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('IssuingAuthoritySignature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getIssuingAuthoritySignatureImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('IssuingAuthoritySignature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }



  //ID card form for Ex-serviceman
  leftThumbImpessionFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.e.leftThumbImpession="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.leftthumbimpressionimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('leftThumbImpession');
          i.value="";
          if (error.status == 400) {
            this.leftthumbimpressionimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('leftThumbImpession');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getLeftthumbImpressionImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('leftThumbImpession');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //ID card form for Ex-serviceman
  SignatureOfApplicantFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.e.SignatureOfApplicant="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.signatureOfapplicantimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('SignatureOfApplicant');
          i.value="";
          if (error.status == 400) {
            this.leftthumbimpressionimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('SignatureOfApplicant');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getSignatureOfApplicantImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SignatureOfApplicant');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //ID card form for Widows
  RightThumbImpessionFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.w.RightThumbImpession="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.rightthumbimpressionimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('RightThumbImpession');
          i.value="";
          if (error.status == 400) {
            this.rightthumbimpressionimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('RightThumbImpession');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getRightThumbImpressionImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('RightThumbImpession');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


  //ID card form for Widows
  SignatureOfApplicantInWidowsformFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.w.SignatureOfApplicant="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.signatureofapplicantwidowsimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          //console.log(response);
        }, (error) => {
          let i:any=document.getElementById('SignatureOfApplicant');
          i.value="";
          if (error.status == 400) {
            this.rightthumbimpressionimageUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('SignatureOfApplicant');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getsignatureOfApplicantWidowsformImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SignatureOfApplicant');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


//Marriage grant ID card
  Daughter_TCFileInput(file: FileList) {
    //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {

      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";
  
        }, (error) => {
          let i: any = document.getElementById('Daughter_TC');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Daughter_TC');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }
  
  
  getDaughter_TCPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Daughter_TC');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
 


//mg signatureofapplicant
SignatureOfApplicantInMarriageGrantFileInput(file: FileList) {
  
    //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
         this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";
  
        }, (error) => {
          let i: any = document.getElementById('SignatureOfApplicantMG');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('SignatureOfApplicantMG');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }
  
  
  getSAMGPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('SignatureOfApplicantMG');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //CET certificate form UploadMarkssheet
  UploadMarkSheetsFileInput(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('UploadMarkSheets');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('UploadMarkSheets');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    
    getMarksheetPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('UploadMarkSheets');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

    //CET certificate form UploadRecordOffice
    UploadRecordOfficeDocFileInput(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('UploadRecordOfficeDoc');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('UploadRecordOfficeDoc');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    getRecordOfficeDocPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('UploadRecordOfficeDoc');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

    //CET certificate form DischargeBook
    UploadDischargeBookFileInput(file: FileList) {
      
        //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage(data);
          x.subscribe(
            (response) => {
              // console.log(response);
              // this.app.APP_PA_PhotoErrorMessage="";
      
            }, (error) => {
              let i: any = document.getElementById('UploadDischargeBook');
              i.value = "";
              if (error.status == 400) {
                // this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('UploadDischargeBook');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
      
      getDischargebookDocPDFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('UploadDischargeBook');
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }

      //CET certificate form SSLCMarksSheet
      UploadSSLCMarksSheetFileInput(file: FileList) {
      
        //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage(data);
          x.subscribe(
            (response) => {
              // console.log(response);
              // this.app.APP_PA_PhotoErrorMessage="";
      
            }, (error) => {
              let i: any = document.getElementById('UploadSSLCMarksSheet');
              i.value = "";
              if (error.status == 400) {
                // this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('UploadSSLCMarksSheet');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
      
      getSSLCMarksSheetPDFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('UploadSSLCMarksSheet');
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }

       //CET certificate form CETApplication
       UploadCETApplicationFileInput(file: FileList) {
        
          //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
          let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
          let s: any = file.item(0).size / 1024;
          let size: any = parseFloat(s).toFixed(2);
          let uploadedFilename = file.item(0).name;
          if (uploadedFilename.match(regex) && (size <= 5048)) {
            this.fileToUpload = file.item(0);
            var reader = new FileReader();
            reader.onload = (event: any) => {
              // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
            }
            reader.readAsDataURL(this.fileToUpload);
            const data = new FormData();
            data.append("UploadedImage", file.item(0));
            let x = this.userService.uploadImage(data);
            x.subscribe(
              (response) => {
                // console.log(response);
                // this.app.APP_PA_PhotoErrorMessage="";
        
              }, (error) => {
                let i: any = document.getElementById('UploadCETApplication');
                i.value = "";
                if (error.status == 400) {
                  // this.FeasibilityPDFUrl = "assets/images/image-default.png";
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
          }
          else {
            let i: any = document.getElementById('UploadCETApplication');
            i.value = "";
            if (!uploadedFilename.match(regex))
              swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
            else if (size > 2048)
              swal('Warning!', "Please upload image file less than 2mb", 'warning');
          }
        }
        
        getCETApplicationPDFUrl() {
          let imagename = null;
          try {
            imagename = document.getElementById('UploadCETApplication');
            return imagename.files[0].name;
          }
          catch (e) {
            return null;
          }
        }


   //Employment Registration Form  esmsignature
   ESMSignatureFileInputForEMPform(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('ESMSignature');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('ESMSignature');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    getESMSignaturePDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('ESMSignature');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

     //House Repair grant Form  ppoupload
     UploadPPOFileInputForHouseRepairgrantform(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('UploadPPO');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('UploadPPO');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    getUploadPPOPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('UploadPPO');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

    //House Repair grant Form  property papers
    UploadPropertypapersFileInputForHouseRepairgrantform(file: FileList) {
      
        //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage(data);
          x.subscribe(
            (response) => {
              // console.log(response);
              // this.app.APP_PA_PhotoErrorMessage="";
      
            }, (error) => {
              let i: any = document.getElementById('Uploadpropertypapers');
              i.value = "";
              if (error.status == 400) {
                // this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('Uploadpropertypapers');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
      
      getPropertyPapersPDFUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('Uploadpropertypapers');
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }



      //save appl9 State Govt Scholarship details
  SaveAllStateGovtScholarshipDetails(stategovtscholarshipform: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (stategovtscholarshipform.valid) {
        this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;

      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.GetAllApplications(this.UserName);
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    this.SaveStateGovtScholarshipDetails(stategovtscholarshipform);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }


  //Save StateGovtScholarshipDetails
  SaveStateGovtScholarshipDetails(stategovtscholarshipform: NgForm) {    
    
     if (stategovtscholarshipform.valid) {
      this.formInvalid = false;
       document.getElementById('loader-spinner').style.display = "block";
      // stategovtscholarshipform.value.DID_AppliedDate=this.myDate;
      this.data = this.userService.saveStateGovtScholarshipDetails(stategovtscholarshipform.value);
      this.data.subscribe(
        (response) => {
          stategovtscholarshipform.reset();
          stategovtscholarshipform.resetForm();    
          $("#ApplicationForm9").modal('hide');   
          swal('Success!', 'State Govt Scholarship Form Details saved Successfully.', 'success');
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
          this.router.navigate(['/home/dashboardschemes']);
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  //save appl10 Save ChildrenScholarshipGrantDetails
   SaveAllChildrenScholarshipGrantDetails(childrenScholarshipform: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (childrenScholarshipform.valid) {
        this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;

      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.GetAllApplications(this.UserName);
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
      childrenScholarshipform.value.CSG_ServiceNo=this.s.ServiceNo;
    this.SaveChildrenScholarshipGrantDetails(childrenScholarshipform);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }


  //Save ChildrenScholarshipDetails
  SaveChildrenScholarshipGrantDetails(childrenScholarshipform: NgForm) {    
    
     if (childrenScholarshipform.valid) {
      this.formInvalid = false;
       document.getElementById('loader-spinner').style.display = "block";
      // stategovtscholarshipform.value.DID_AppliedDate=this.myDate;
      this.data = this.userService.saveChildrenScholarshipGrantDetails(childrenScholarshipform.value);
      this.data.subscribe(
        (response) => {
          childrenScholarshipform.reset();
          childrenScholarshipform.resetForm();    
          $("#ApplicationForm10").modal('hide');   
          swal('Success!', 'Children Scholarship Grant Form Details saved Successfully.', 'success');
          this.GetAllSainikSchemes(this.itemsPerPage, 1);
          this.GetAllApplications(this.UserName);
          this.router.navigate(['/home/dashboardschemes']);
          document.getElementById('loader-spinner').style.display = "none";        
        }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }



  // appl10 GetDetailsForChildrenGrantScholarshipform
  GetDetailsForChildrenGrantScholarshipform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForChildrenGrantScholarshipform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.cs = data;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  // appl11 GetDetailsForGallantryNonGallantryform
  GetDetailsForGallantryNonGallantryform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForGallantryNonGallantryform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.gn = data;
          if(data.GNG_DateofCommission!=null)
          this.gn.GNG_DateofCommission=((data.GNG_DateofCommission).split('T'))[0];
          if(data.GNG_ReceivedDate!=null)
          this.gn.GNG_ReceivedDate=((data.GNG_ReceivedDate).split('T'))[0];
          if(data.GNG_grantDate!=null)
          this.gn.GNG_grantDate=((data.GNG_grantDate).split('T'))[0];
          if(data.GNG_Date!=null)
          this.gn.GNG_Date=((data.GNG_Date).split('T'))[0];

          if(data.GNG_PR_Pincode==0)
          this.gn.GNG_PR_Pincode="";
          if(data.GNG_PA_Pincode==0)
          this.gn.GNG_PA_Pincode="";   
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //appl12 GetDetailsForDeathReliefGrantform
  GetDetailsForDeathReliefGrantform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForDeathReliefGrantform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.drg = data;
          if(data.DRG_ExservicemanDeathDate!=null)
          this.drg.DRG_ExservicemanDeathDate=((data.DRG_ExservicemanDeathDate).split('T'))[0];
          if(data.DRG_Ex_Date!=null)
          this.drg.DRG_Ex_Date=((data.DRG_Ex_Date).split('T'))[0];
          if(data.DRG_Ex_JoiningDate!=null)
          this.drg.DRG_Ex_JoiningDate=((data.DRG_Ex_JoiningDate).split('T'))[0];
          if(data.DRG_Ex_RelievingDate!=null)
          this.drg.DRG_Ex_RelievingDate=((data.DRG_Ex_RelievingDate).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  //appl13 GetDetailsForCashAwardform
  GetDetailsForCashAwardform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForCashAwardform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.ca = data;
          if(data.CATM_Date!=null)
          this.ca.CATM_Date=((data.CATM_Date).split('T'))[0];

          if(data.CATM_PR_Pincode==0)
          this.ca.CATM_PR_Pincode="";
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  //appl14 GetDetailsForAnnualReliefGrantForm
  GetDetailsForAnnualReliefGrantForm(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForAnnualReliefGrantForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.arg = data;
          if(data.ARG_RS_RelievingDate!=null)
          this.arg.ARG_RS_RelievingDate=((data.ARG_RS_RelievingDate).split('T'))[0];
          if(data.ARG_RS_JoingDate!=null)
          this.arg.ARG_RS_JoingDate=((data.ARG_RS_JoingDate).split('T'))[0];
          if(data.ARG_MDate!=null)
          this.arg.ARG_MDate=((data.ARG_MDate).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }




  //save appl11 Save GallantryNonGallantryForm Details
  SaveAllGallantryNonGallantryFormDetails(GNGform: NgForm){
    
     if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
     {
      if (GNGform.valid) {
        this.formInvalid = false;
      if(this.gn.GNG_GazetteNotificationUpload==null|| this.gn.GNG_GazetteNotificationUpload==undefined || this.gn.GNG_ParchmentUpload==null|| this.gn.GNG_ParchmentUpload==undefined)  
      {
          swal('Warning!', 'Please Upload Gazette Notification and Parchment.', 'warning');
      }
      else{
      //this.SaveGallantryNonGallantryFormDetails(GNGform);
     document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

      this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
      this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
      this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.GetAllApplications(this.UserName);
        //this.closeModalDialogApplicationForms(this.id);
        //this.router.navigate(['/home/SchemesApprovals']);
        this.router.navigate(['/home/dashboardschemes']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    }
     this.SaveGallantryNonGallantryFormDetails(GNGform);
    }
    else{
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
     }
    }
    else{
      swal("Please select Service No.")
    }
  }


  
// appl11 Save GallantryNonGallantryForm Details
SaveGallantryNonGallantryFormDetails(GNGform: NgForm) {  
  
  // if(this.gn.GNG_GazetteNotificationUpload==null|| this.gn.GNG_GazetteNotificationUpload==undefined || this.gn.GNG_ParchmentUpload==null|| this.gn.GNG_ParchmentUpload==undefined)  
  // {
  //     swal('Warning!', 'Please Upload Gazette Notification and Parchment.', 'warning');
  // }

   if (GNGform.valid) {
    this.formInvalid = false;
     document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.saveGallantryNonGallantryFormDetails(GNGform.value);
    this.data.subscribe(
      (response) => {
        GNGform.reset();
        GNGform.resetForm();    
        $("#ApplicationForm11").modal('hide');   
        swal('Success!', 'Gallantry and NonGallantry Form Details saved Successfully.', 'success');
        this.GetAllSainikSchemes(this.itemsPerPage, 1);
        this.GetAllApplications(this.UserName);
        this.router.navigate(['/home/dashboardschemes']);
        document.getElementById('loader-spinner').style.display = "none";        
      }, (error) => {
         document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
      });
    }
  else {
    swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    this.formInvalid = true;
  }
}



 //save appl12 SaveAppl DeathReliefGrantForm Details
 SaveAllDeathReliefGrantFormDetails(DRGform: NgForm){
  
   if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
   {
    if (DRGform.valid) {
      this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.sainikSchemeApplicationModel.Scheme_Id = this.id;
    this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

    this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
    this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
    this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;

    this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
    (data:any) => {
      document.getElementById('loader-spinner').style.display = "none";
      swal('','Application Form Submitted Successfully!','success');
      this.GetAllSainikSchemes(this.itemsPerPage, 1);
      this.GetAllApplications(this.UserName);
      //this.closeModalDialogApplicationForms(this.id);
      //this.router.navigate(['/home/SchemesApprovals']);
      this.router.navigate(['/home/dashboardschemes']);
    }, (error) => {
      document.getElementById('loader-spinner').style.display="none";
      this.errorHandler.HandlerError(error);
    });
  this.SaveDeathReliefGrantFormDetails(DRGform);
  }
  else{
    swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    this.formInvalid = true;
   }
  }
  else{
    swal("Please select Service No.")
  }
}

// appl12 Save DeathReliefGrantForm Details
SaveDeathReliefGrantFormDetails(DRGform: NgForm) {    
  if (DRGform.valid) {
   this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
   this.data = this.userService.saveDeathReliefGrantFormDetails(DRGform.value);
   this.data.subscribe(
     (response) => {
      DRGform.reset();
      DRGform.resetForm();    
       $("#ApplicationForm12").modal('hide');   
       swal('Success!', 'Death Relief Grant Form Details saved Successfully.', 'success');
       this.GetAllSainikSchemes(this.itemsPerPage, 1);
       this.GetAllApplications(this.UserName);
       this.router.navigate(['/home/dashboardschemes']);
       document.getElementById('loader-spinner').style.display = "none";        
     }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
           if (error.status == 401) {
             this.errorHandler.HandlerError(error);
           }
           else if (error.status == 400) {
             swal('Warning!', error.error.Message, 'warning');
           }
     });
 }
 else {
   swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
   this.formInvalid = true;
 }
}


//save appl13 SaveAppl CashAwardForm Details
SaveAllCashAwardFormDetails(caform: NgForm){
  
   if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
   {
    if (caform.valid) {
      this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.sainikSchemeApplicationModel.Scheme_Id = this.id;
    this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

    this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
    this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
    this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
    this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
    (data:any) => {
      document.getElementById('loader-spinner').style.display = "none";
      swal('','Application Form Submitted Successfully!','success');
      this.GetAllSainikSchemes(this.itemsPerPage, 1);
      this.GetAllApplications(this.UserName);
      //this.closeModalDialogApplicationForms(this.id);
      //this.router.navigate(['/home/SchemesApprovals']);
      this.router.navigate(['/home/dashboardschemes']);
    }, (error) => {
      document.getElementById('loader-spinner').style.display="none";
      this.errorHandler.HandlerError(error);
    });
  this.SaveCashAwardFormDetails(caform);
  }
  else{
    swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    this.formInvalid = true;
   }
  }
  else{
    swal("Please select Service No.")
  }
}

// appl13 Save CashAwardForm Details
SaveCashAwardFormDetails(caform: NgForm) { 
     
  if (caform.valid) {
   this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
   this.data = this.userService.saveCashAwardFormDetails(caform.value);
   this.data.subscribe(
     (response) => {
      caform.reset();
      caform.resetForm();    
       $("#ApplicationForm13").modal('hide');   
       swal('Success!', 'Cash Award Form Details saved Successfully.', 'success');
       this.GetAllSainikSchemes(this.itemsPerPage, 1);
       this.GetAllApplications(this.UserName);
       this.router.navigate(['/home/dashboardschemes']);
       document.getElementById('loader-spinner').style.display = "none";        
     }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
           if (error.status == 401) {
             this.errorHandler.HandlerError(error);
           }
           else if (error.status == 400) {
             swal('Warning!', error.error.Message, 'warning');
           }
     });
 }
 else {
   swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
   this.formInvalid = true;
 }
}



//save appl14 SaveAppl AnnualReliefGrantForm Details
SaveAllAnnualReliefGrantFormDetails(argform: NgForm){
  
   if (this.s.ServiceNo!=null ||this.s.ServiceNo!=undefined)
   {
    if (argform.valid) {
    this.formInvalid = false;
  document.getElementById('loader-spinner').style.display = "block";
    this.sainikSchemeApplicationModel.Scheme_Id = this.id;
    this.sainikSchemeApplicationModel.ServiceNo = this.s.ServiceNo;

    this.sainikSchemeApplicationModel.ApplicationStatus=this.ApplicationStatus;
    this.sainikSchemeApplicationModel.ApplicationId=this.ApplicationId;
    this.sainikSchemeApplicationModel.ApplicationStatusName=this.ApplicationStatusName;
    this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
    (data:any) => {
      document.getElementById('loader-spinner').style.display = "none";
      swal('','Application Form Submitted Successfully!','success');
      this.GetAllSainikSchemes(this.itemsPerPage, 1);
      this.GetAllApplications(this.UserName);
      //this.closeModalDialogApplicationForms(this.id);
      //this.router.navigate(['/home/SchemesApprovals']);
      this.router.navigate(['/home/dashboardschemes']);
    }, (error) => {
      document.getElementById('loader-spinner').style.display="none";
      this.errorHandler.HandlerError(error);
    });
  this.SaveAnnualReliefGrantFormDetails(argform);
  }
  else{
    swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    this.formInvalid = true;
   }
  }
  else{
    swal("Please select Service No.")
  }
}

// appl14 Save CashAwardForm Details
SaveAnnualReliefGrantFormDetails(argform: NgForm) {
      
  if (argform.valid) {
   this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
   this.data = this.userService.saveAnnualReliefGrantFormDetails(argform.value);
   this.data.subscribe(
     (response) => {
      argform.reset();
      argform.resetForm();    
       $("#ApplicationForm14").modal('hide');   
       swal('Success!', 'Annual Relief Grant Form Details saved Successfully.', 'success');
       this.GetAllSainikSchemes(this.itemsPerPage, 1);
       this.GetAllApplications(this.UserName);
       this.router.navigate(['/home/dashboardschemes']);
       document.getElementById('loader-spinner').style.display = "none";        
     }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
           if (error.status == 401) {
             this.errorHandler.HandlerError(error);
           }
           else if (error.status == 400) {
             swal('Warning!', error.error.Message, 'warning');
           }
     });
 }
 else {
   swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
   this.formInvalid = true;
 }
}



//Cash Award Upload For GazetteNotification
GazetteNotificationFileInput(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.ca.CATM_GazetteNotification="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('CATM_GazetteNotification');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('CATM_GazetteNotification');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getGazetteNotificationImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('CATM_GazetteNotification');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


//CashAwardDetails Upload
CashAwardUploadFileInput(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.ca.CATM_CashAwardUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('CashAwardUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('CashAwardUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getCashAwardDetailsImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('CashAwardUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}





//CashAwardDetails Upload for CO_Signature
CO_SignatureUploadFileInput(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.ca.CATM_COSignature="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('COSignature');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('COSignature');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getCOSignatureDetailsImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('COSignature');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}




//StateGovtScholarship Upload for HostelBill
UploadHostelBillFileInputForStateGovtScholarshipForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.ca.CATM_COSignature="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('sgshostelbillupload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('sgshostelbillupload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getHostelbillDetailsImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('sgshostelbillupload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}



//StateGovtScholarship Upload for GuardianSignature
GuardianSignatureFileInputForStateGovtScholarshipForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.sgs.SGS_GuardianSignature="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('guardianSignature');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('guardianSignature');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getGuardianSignatureImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('guardianSignature');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//Children Scholorship form
 //ExSignature
ExSignatureFileInputForChildrenScholarshipForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.cs.CSG_ExSignature="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('CSG_ExSignature');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('CSG_ExSignature');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getExSignatureImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('CSG_ExSignature');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


// ChildrenScholarship StudentSignature
StudentSignatureFileInputForChildrenScholarshipForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.cs.CSG_StudentSignature="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('StudentSignature');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('StudentSignature');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getStudentSignatureImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('StudentSignature');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}



// GNG Award form 
//1.PosthumousProofUpload
PosthumousProofUploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_PosthumousProofUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('PosthumousProofUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('PosthumousProofUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getPosthumousProofUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('PosthumousProofUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}



// GNG Award form 
//2.GazetteNotificationUpload
GNG_GazetteNotificationUploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_GazetteNotificationUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('gng_GazetteNotificationUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('gng_GazetteNotificationUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getGnG_GazetteNotificationUploadUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('gng_GazetteNotificationUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//3.CitationUpload
CitationUploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_CitationUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('CitationUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('CitationUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getCitationUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('CitationUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//4.ParchmentUpload
ParchmentUploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_ParchmentUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('ParchmentUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ParchmentUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getParchmentUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('ParchmentUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//5.LeavingCertificateupload
LeavingCertificateuploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_LeavingCertificateupload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('LeavingCertificateupload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('LeavingCertificateupload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getLeavingCertificateuploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('LeavingCertificateupload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//6.SchoolLeavingCertificate
SchoolLeavingCertificateFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_SchoolLeavingCertificate="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('SchoolLeavingCertificate');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('SchoolLeavingCertificate');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getSchoolLeavingCertificateuploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('SchoolLeavingCertificate');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//7.DomicileProofUpload
DomicileProofUploadFileInputForGNGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.gn.GNG_DomicileProofUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('DomicileProofUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('DomicileProofUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getDomicileProofUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('DomicileProofUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


//Death Relief Grant Form
 //1.PensionPaymentUpload
 PensionPaymentUploadFileInputForDRGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.drg.DRG_PensionPaymentUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('PensionPaymentUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('PensionPaymentUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getPensionPaymentUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('PensionPaymentUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//2.DeathCertificateUpload
DeathCertificateUploadFileInputForDRGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.drg.DRG_DeathCertificateUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('DeathCertificateUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('DeathCertificateUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getDeathCertificateUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('DeathCertificateUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//3.BankPassbookUpload
BankPassbookUploadFileInputForDRGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.drg.DRG_BankPassbookUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('BankPassbookUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('BankPassbookUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getBankPassbookUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('BankPassbookUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//4.DischargeBookUpload
DischargeBookUploadFileInputForDRGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.drg.DRG_DischargeBookUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('DischargeBookUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('DischargeBookUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getDischargeBookUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('DischargeBookUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//5.IdCardUpload
IdCardUploadFileInputForDRGForm(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.drg.DRG_IdCardUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('IdCardUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('IdCardUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getIdCardUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('IdCardUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


PrintDependentId = function () {
  window.print();
}

//MarriageRegistrationUploadFileInput for marriage grant form

MarriageRegistrationUploadFileInput(file: FileList) {
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|.PDF)$/;
  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
  if (uploadedFilename.match(redexe)){
    swal('Warning!', "File type .exe is not allowed", 'warning');
    this.m.MarriageRegistrationUpload="";
    return true;
  }
  if (uploadedFilename.match(regex) && (size <= 2048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
     // this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage(data);
    x.subscribe(
      (response) => {
        //console.log(response);
      }, (error) => {
        let i:any=document.getElementById('MarriageRegistrationUpload');
        i.value="";
        if (error.status == 400) {
          //this.signatureimageUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('MarriageRegistrationUpload');
    i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload image file with extension jpg, jpeg or png or  PDF or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getMarriageRegistrationUploadImage() {
  let imagename = null;
  try {
    imagename = document.getElementById('MarriageRegistrationUpload');
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

  //IdCard upload in Exservice man
  UploadFOrIdExServiceMan(file: FileList) {
    
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|.pdf|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.signatureofapplicantmarriagegrantimageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
    
          }, (error) => {
            let i: any = document.getElementById('UploadIdNumber');
            i.value = "";
            if (error.status == 400) {
              // this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('UploadIdNumber');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    
    GetIdCardNumberUpload() {
      let imagename = null;
      try {
        imagename = document.getElementById('UploadIdNumber');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }



}


// WEBPACK FOOTER //
// ./src/app/schemes/dashboard/dashboard.component.ts